export class SessionStorageModel {
  ApigeeToken: string = "";
  AzureToken: string = "";
}